const AddNewShipReducer = (state = {}, action) => {
    switch (action.type) {
      case "GETPROJECT_ID":
        return {
          getprojectid: action.data,
        };
      case "GETBASICINFO_PROJECT":
        return Object.assign({}, state, {
          getbasicinfo: action.data,
        });
      case "GETSHIPINFO_PROJECT":
        return Object.assign({}, state, {
          getshipinfo: action.data,
        });
      case "GETPROCESSINFO_PROJECT":
        return Object.assign({}, state, {
          getprocessinfo: action.data,
        });
      case "FORMAT_VALUES":
        return Object.assign({}, state, {
          Format: action.data,
        });
      case "TIME_VALUES":
        return Object.assign({}, state, {
          Time: action.data,
        });
      default:
        return state;
    }
  };
  
  export default AddNewShipReducer;